import CanvasCore from 'CanvasCore'
import React, { useRef } from 'react'
import { getComponentCanvasSize } from 'Editor/utils/fullscreenType'
import Overlay from './Overlay'

const CanvasPanel = ({ draft }) => {
  const drawRef = useRef(null)
  // 合成坐标：普通 512²，全屏 1024²，3:4 768×1024。draft.ow/oh 是产出尺寸（可为 512×912 / 512×683）
  const base = getComponentCanvasSize(draft?.fullscreenType)
  return (
    <div className="relative w-full h-full">
      <CanvasCore
        ow={base.w}
        oh={base.h}
        baseSize={base.w}
        baseHeight={base.h}
        drawRef={drawRef}
      />
      <Overlay draft={draft} />
    </div>
  )
}

export default CanvasPanel
